import { ITEM_STATUSES } from '@updater-core/constants/items';
import { waitFor } from '@updater-core/lib/async';
import { createStore } from '@updater-core/lib/store';
import { mapAddress } from '@updater-apps/full-service-move/utils';
import { FsmInteractor, FsmState } from './types';
import * as actions from './actions';
import * as selectors from './selectors';

// import { loggerMiddleware } from '@updater-core/lib/logger';
export const STORAGE_KEY = 'upd.fullservicemove';

export default function createInteractor({
  session,
  // optimizely,
  moveItems,
  currentFormIndex,
  // tracker,
  gateways: { storage, fullServiceMoveGateway },
}): FsmInteractor {
  const sessionState = session.getState();
  const newFormData = selectors.formData(sessionState); // get this from server side

  const initialState: FsmState = {
    currentFormIndex,
    moveId: session.selectors.currentMoveId(sessionState),
    fromAddress: mapAddress(
      session.selectors.currentMoveFromAddress(sessionState)
    ),
    toAddress: mapAddress(session.selectors.currentMoveToAddress(sessionState)),
    moveDate: session.selectors.currentMoveDate(sessionState),
    homeSize: session.selectors.fromHomeSize(sessionState),
    ...newFormData,
  };

  const store = createStore<FsmState>(initialState, []);

  storage.subscribeJSON(STORAGE_KEY, async ({ newValue }) => {
    if (newValue) {
      const { debugChange, ...newState } = newValue;
      if (debugChange) {
        store.setState(newState);
      }
    }
  });

  return {
    ...store,
    experimentInitialized: waitFor(
      store,
      (state) => state.loadingExperiment === false
    ),
    actions: {
      init: actions.init({
        store,
      }),
      submit: actions.submit({
        session,
        store,
        fullServiceMoveGateway,
        moveItems,
      }),
      update: actions.update({ store }),
      validate: actions.validate(),
      transformErrors: actions.transformErrors(),
      navigateTo: actions.navigateTo({ store }),
      getAvailableAppointments: actions.getAvailableAppointments({
        session,
        store,
        fullServiceMoveGateway,
      }),
      getBookedAppointment: actions.getBookedAppointment({
        session,
        store,
        fullServiceMoveGateway,
      }),
      setEligibleForFsm: actions.setEligibleForFsm({ store }),
      markStepAsStarted: actions.markStep({
        store,
        actions: moveItems.actions,
        status: ITEM_STATUSES.STARTED,
      }),
      markStepAlreadyDone: actions.markStep({
        store,
        actions: moveItems.actions,
        status: ITEM_STATUSES.ALREADY_DONE,
      }),
    },
    selectors: {
      formData: selectors.formData,
      fsmStatus: selectors.fsmStatus,
      bookedTime: selectors.bookedTime,
      bookedDate: selectors.bookedDate,
      fsmCardConfig: selectors.fsmCardConfig,
      isEligibleForFsm: selectors.isEligibleForFsm,
    },
  };
}
